module.exports = __webpack_public_path__ + "img/activity3.53acb656.svg";